export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 sm:py-32">
      <div className="container-wide grid lg:grid-cols-[1fr_1.1fr] gap-12 lg:gap-20 items-center">
        <div className="reveal relative">
          <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-[#E05947]/40 rounded-2xl" />
          <div className="absolute -bottom-4 -right-4 w-32 h-32 border-2 border-[#5979A9]/30 rounded-2xl" />
          <img
            src="/images/about.jpg"
            alt="Inside Himalayan Cafe"
            className="relative rounded-2xl shadow-2xl shadow-[#5979A9]/15 object-cover w-full h-[520px]"
          />
        </div>

        <div className="reveal">
          <div className="eyebrow mb-4">Our Story</div>
          <h2 className="section-title text-4xl sm:text-5xl lg:text-6xl mb-7">
            About <em className="italic text-[#E05947]">Himalayan Cafe</em>
          </h2>
          <div className="space-y-5 text-[#4A5568] text-lg leading-relaxed">
            <p>
              Himalayan Cafe was born from a passion for good food and genuine hospitality. After
              more than 12 years working as a chef, our founder finally had the opportunity to create a place
              that felt truly personal.
            </p>
            <p>
              Inspired by the Himalayan region of Northern India, Himalayan Cafe combines fresh ingredients,
              made-to-order dishes and a warm atmosphere where everyone feels welcome.
            </p>
            <p>
              Whether you're joining us for breakfast, lunch, dinner or simply a great coffee, we invite you
              to slow down, relax and enjoy the moment.
            </p>
          </div>

          <div className="mt-9 grid grid-cols-3 gap-4">
            {[
              ["12+", "Years of crafting flavour"],
              ["Made", "to order, daily"],
              ["All", "ages welcome"],
            ].map(([k, v]) => (
              <div key={v} className="bg-white border border-[#F0EAE6] rounded-2xl p-4 text-center shadow-sm">
                <div className="font-serif-display text-2xl sm:text-3xl text-[#5979A9]">{k}</div>
                <div className="text-xs sm:text-sm text-[#4A5568] mt-1">{v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
